// @mui
import { Box, BoxProps } from '@mui/material';
import Image from './Image';

// ----------------------------------------------------------------------

interface Props extends BoxProps {
  disabledLink?: boolean;
}

export default function Logo({ disabledLink = false, sx }: Props) {
  // OR
  // const logo = '/logo/logo_single.svg';

  const logo = (
    <Box sx={{ width: 60, height: 60, ...sx }}>
      <Image src="https://www.dnevnik.rs/sites/default/files/styles/single_article_main_image/public/2018-06/logo-general_20150119091755342_0.jpg?itok=uNlYOL0T" alt="logo" />
    </Box>
  );

  if (disabledLink) {
    return <>{logo}</>;
  }

  return <>{logo}</>;
}
